import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import Lottie from 'lottie-react';
import Loader from '../../../assests/animation/Loader2.json';
import OverallReview from '../../../components/OverallReview/OverallReview';
import SampleImg from '../../../assests/images/sampleimg.png'
import {
  CommentIcon,
  HeartLike,
  Instagram,
  InstagramIconSmall,
  InstagramLogo,
  InstaShareIcon,
  X_icon,
} from '../../../Common/SvgIcon/CommonSvgIcons';
import Insta from '../../../assests/images/Instagram.png';
import GraphHOC from '../../../Common/GraphHOC/GraphHOC';
import TrendsInUserActivity from '../../../Common/TendsInUserActivity/TrendsInUser_activity';
import BarGraph from '../../../Common/BarGraph/BarGraph';
import RatingDonutChart from '../../../Common/RatingDonutChart/DonutChart';
import DonutChart from '../../../Common/SentimentCharts/SentimentCharts';
import FunnelGraph from '../../../Common/FunnelGraph/FunnelGraph';
import VerticalBarGraph from '../../../Common/BarGraph/VarticalBargraph';
import { format, parse } from 'date-fns';
import { useParsedEndDate, useParsedStartDate } from '../../../utils/ParseDate';
import DynamicCorrelationGraph from '../../../components/DynamicCorrelationGraph/DynamicCorrelationGraph';
import { useDispatch } from 'react-redux';
import { DetailedInsightsData } from '../../../store/redux/slices/topicSlice';
import SidePanel from '../../../components/SidePanel/SidePanel';
import {
  convertDateFormat,
  convertDateFormatString,
} from '../../../utils/ConvertDateFormat';
import TitleWithInfo from '../../../Common/TitleWithInfo/TitleWithInfo';
import { formatNumber } from '../../../utils/NumberFormatter';

const LoaderDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80vh;
    & > svg {
    
    width: 300px;
    height: 300px;
    }
}
`;
const Wrapper = styled.div`
  padding: 30px;
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;
const Container = styled.div`
  display: flex;
  gap: 30px;
  height: 380px;
`;

const ChildContainer = styled.div`
  flex: 1;
  height: 100%;
  border-radius: 15px;
  border: 1px solid #d9d9d9;

  display: flex;
  justify-content: ${(props) => (props.justify ? props.justify : 'center')};
  align-items: center;
  box-sizing: border-box;
`;

const ChildContainer1 = styled(ChildContainer)`
  width: 50%;
  height: max-content;
`;
const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 15px;
  border: 1px solid #d9d9d9;
  /* justify-content: center; */
  /* align-items: center; */
  box-sizing: border-box;
  padding: 5px;

  span {
    color: #636363;
    font-family: Montserrat;
    font-size: 15px;
    font-weight: 500;

    justify-content: space-between;
    align-items: center;
    margin: 10px 0px 0px 10px;
  }

  div {
    margin: 10px 0px 0px 0px;
  }
`;

const BestPerfMainDiv = styled.div` 
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 10px 15px;
    box-sizing: border-box;

    & > .nextDiv {
        min-height: 50px;
    margin: 0px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    /* justify-content: center; */
    gap: 5px;
    min-height: 50px;
    }
    
    & > .bodyDiv {
    
    height: 298px;
    width: 100%;
    }
`;
const Span = styled.span`
  color: rgba(0, 0, 0, 0.87);
  font-family: Open Sans;
  font-size: 11px;
  font-weight: 400;
  align-self: flex-end;
  margin-right: 10px;
  margin-bottom: -4px;
  font-family:'Inter';
`;
const LikesStyle = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-style: Regular;
  font-size: 15px;
  leading-trim: NONE;
  letter-spacing: 0%;
  text-transform: capitalize;
  margin-left:10px;
  display: flex;
  align-items: center;


`;

const OverviewTabInsta = ({
  overview_tab,
  startDate = '',
  endDate = '',
  filteredStartDate,
  filteredEndDate,
  filterOption,
  preview_uuid,
  filteredData,
  job_id,
  resetFlag,
  view,
  channel,
  handleTabClick,
  hideDropdown,
  formatValue = 'dd-yyyy-MM',
  child = [],
}) => {
  const isSectionEnabled = (name) => {
    if (!child || child.length === 0) return true;
    const found = child.find((c) => c.name === name);
    return found ? found.value === true : false;
  };
  const options = ['Bar Graph', 'Pie Chart', 'Donut Chart', 'Funnel Chart'];
  const rawData = [
    {
      name: 'Likes',
      value: resetFlag && filteredData
        ? filteredData?.engagement?.likes
        : overview_tab?.engagement?.likes || 0,
    },
    {
      name: 'Comments',
      value: resetFlag && filteredData
        ? filteredData?.engagement?.comments
        : overview_tab?.engagement?.comments || 0,
    },
    {
      name: 'Views',
      value: resetFlag && filteredData
        ? filteredData?.engagement?.views
        : overview_tab?.engagement?.views || 0,
    }
  ];
  const sortedEng = [...rawData].sort((a, b) => b.value - a.value);
  const shades = [
    'rgba(45, 137, 85, 1)',    // darkest
    'rgba(45, 137, 85, 0.7)',  // medium
    'rgba(45, 137, 85, 0.4)',  // lightest
  ];

  sortedEng.forEach((item, index) => {
    item.fill = shades[index];
  });

  const engagementData = rawData.map(item =>
    sortedEng.find(s => s.name === item.name)
  );


  const genderDemographicsData = [
    {
      name: 'Male',
      value:
        resetFlag === true && filteredData
          ? filteredData?.gender_demographics?.male_percentage
          : overview_tab?.gender_demographics?.male_percentage || 0,
      // fill: '#6640B8',
      fill: '#3D9FF8',
    },
    {
      name: 'Female',
      value:
        resetFlag === true && filteredData
          ? filteredData?.gender_demographics?.female_percentage
          : overview_tab?.gender_demographics?.female_percentage || 0,
      // fill: '#EAAABD',
      fill: '#FF9AB8',
    },
    {
      name: 'Unknown',
      value:
        resetFlag === true && filteredData
          ? filteredData?.gender_demographics?.unknown_percentage
          : overview_tab?.gender_demographics?.unknown_percentage || 0,
      // fill: '#E4E4E4',
      fill: 'rgba(218, 217, 219,  0.8)',
    },
  ];

  const totalNoOfPosts =
    resetFlag === true && filteredData
      ? filteredData?.total_count
      : overview_tab?.total_count;

  const renderScreen = {
    'Bar Graph':
      view === 'vertical' ? (
        <VerticalBarGraph
          width='105px'
          data={engagementData}
          /*  type={'%'} */
          view={view}
          showFormatted
          showDrillThrough={false}
        />
      ) : (
        <BarGraph
          data={engagementData}
          showFormatted
          isSmall={true}
          showDrillThrough={false}
          /*  type={'%'} */
          borderRadius={'3px 0px 0px 3px'}
          barHeight={'35px'}
          view={view}
        />
      ),
    'Pie Chart': (
      <RatingDonutChart
        showDrillThrough={false}
        data={engagementData}
        width={450}
      />
    ),
    'Donut Chart': (
      <DonutChart showDrillThrough={false} data={engagementData} />
    ),
    'Funnel Chart': (
      <FunnelGraph
        showDrillThrough={false}
        showFormatted
        data={engagementData}
      />
    ),
  };

  const renderGenderDemography = {
    'Bar Graph':
      view === 'vertical' ? (
        <VerticalBarGraph
          width='105px'
          data={genderDemographicsData}
          type={'%'}
          view={view}
          showDrillThrough={true}
          job_id={job_id}
          handleTabClick={(data) => handleTabClick(data)}
        />
      ) : (
        <BarGraph
          data={genderDemographicsData}
          type={'%'}
          isSmall
          borderRadius={'3px 0px 0px 3px'}
          barHeight={'35px'}
          view={view}
          showDrillThrough={true}
          job_id={job_id}
          handleTabClick={(data) => handleTabClick(data)}
        />
      ),
    'Pie Chart': (
      <RatingDonutChart
        data={genderDemographicsData}
        width={450}
        type='percentage'
        showDrillThrough={true}
        job_id={job_id}
        handleTabClick={(data) => handleTabClick(data)}
      />
    ),
    'Donut Chart': (
      <DonutChart
        showDrillThrough={true}
        job_id={job_id}
        handleTabClick={(data) => handleTabClick(data)}
        data={genderDemographicsData}
        type='percentage'
      />
    ),
    'Funnel Chart': (
      <FunnelGraph
        showDrillThrough={true}
        job_id={job_id}
        handleTabClick={(data) => handleTabClick(data)}
        data={genderDemographicsData}
        type={'%'}
      />
    ),
  };

  const [chartType, setChartType] = useState('Volume');

  const startDateParsed = useParsedStartDate(
    resetFlag,
    filteredStartDate,
    startDate,
    formatValue
  );
  const endDateParsed = useParsedEndDate(
    resetFlag,
    filteredEndDate,
    endDate,
    formatValue
  );
  const [graphData, setGraphData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [showSidePanel, setShowSidePanel] = useState(false);

  const dispatch = useDispatch();
  const [weekType, setWeekType] = useState(false);
  const [date, setDate] = useState('');

  const handleDataInsightsFetch = async (data) => {
    var inputData = convertDateFormat(data?.date);
    var filter_key = [];

    if (data?.likes_count !== undefined) {
      filter_key.push('likes');
    }
    if (data?.comments_count !== undefined) {
      filter_key.push('comments');
    }
    if (data?.reposts !== undefined) {
      filter_key.push('reposts');
    }
    if (data?.views !== undefined) {
      filter_key.push('views');
    }

    setDate(convertDateFormatString(inputData?.dateString));
    dispatch(
      DetailedInsightsData({
        preview_uuid: preview_uuid,
        job_id: job_id,
        insight_date: inputData?.dateString,
        insight_type: weekType === true ? 'week' : inputData?.type,
        filter_key: filter_key,
      })
    )
      .then((res) => {
        setGraphData(res?.payload?.response);
      })
      .catch((error) => {
        console.error('Error fetching insights:', error);
      });
  };

  return (
    <>
      {resetFlag === true && filteredData === undefined ? (
        <LoaderDiv style={{ marginTop: '-80px' }}>
          <Lottie
            data-testid='loader'
            animationData={Loader}
            loop={true}
            width='100px'
            height='100px'
          />
        </LoaderDiv>      
      ) : (
        <Wrapper>
          <SidePanel
            isOpen={showSidePanel}
            setIsOpen={(data) => setShowSidePanel(data)}
            pointGraphData={graphData}
            channel={channel}
            date={date}
            isLoading={graphData === null ? true : false}
            startDate={startDateParsed}
            endDate={endDateParsed}
            chartType={chartType}
          />
          {(isSectionEnabled('Overall Posts') || isSectionEnabled('Engagement')) && (
            <Container>
              {isSectionEnabled('Overall Posts') && (
                <ChildContainer justify='flex-start'>
                  <OverallReview
                    inforText='The total number of posts relevant to your topic within the specified time period.'
                    backgroundColor='rgba(45, 137, 85, 1)'
                    icon={<img src={Insta} style={{ width: '35px' }} />}
                    message={
                      startDateParsed?.length < 1 ||
                        startDateParsed === undefined ||
                        startDateParsed === null
                        ? `${totalNoOfPosts} Relevant posts were observed for this evaluation`
                        : `${totalNoOfPosts} Relevant posts were observed From ${startDateParsed} to ${endDateParsed}`
                    }
                  />
                </ChildContainer>
              )}

              {isSectionEnabled('Engagement') && (
                <ChildContainer>
                  <GraphHOC
                    title={'Engagement'}
                    options={options}
                    renderScreen={renderScreen}
                    startDate={startDateParsed}
                    endDate={endDateParsed}
                    option={filterOption}
                    hideDropdown={hideDropdown}
                    formatValue={formatValue}
                    infoText='The total number of likes and comments on posts relevant to your topic within the specified time period.'
                  />
                </ChildContainer>
              )}
            </Container>
          )}
          {(isSectionEnabled('Gender Demographics') || isSectionEnabled('Best Performing Posts - Instagram')) && (
            <Container>
              {isSectionEnabled('Gender Demographics') && (
                <ChildContainer>
                  <GraphHOC
                    title={'Gender Demographics'}
                    options={options}
                    renderScreen={renderGenderDemography}
                    startDate={startDateParsed}
                    endDate={endDateParsed}
                    option={filterOption}
                    hideDropdown={hideDropdown}
                    formatValue={formatValue}
                    infoText='The percentage gender distribution of user accounts relevant to your query, with categories for Male, Female, and Unknown when gender data is unavailable.'
                  />
                </ChildContainer>
              )}

              {isSectionEnabled('Best Performing Posts - Instagram') && (
                <ChildContainer>
                  <BestPerfMainDiv>
                    <div className='nextDiv'>
                      <TitleWithInfo title={"Best Performing Posts - Instagram"} infoText={"Posts are ranked based on total engagement (Likes + Comments) within the selected time period. The post with the highest combined count is marked as the Top Performing Post."} />
                    </div>
                    <div className='bodyDiv'>
                      {/* overview_tab?.best_performing_post?.s3Val */}
                      <img src={overview_tab?.best_performing_post?.s3Val || ''} style={{ height: '260px', width: '100%', objectFit: 'contain' }}
                        onClick={() => {
                          const postUrl = overview_tab?.best_performing_post?.post_url;
                          if (postUrl) {
                            window.open(postUrl, '_blank', 'noopener,noreferrer');
                          }
                        }} />

                      <LikesStyle>
                        <span style={{ display: 'flex', alignItems: 'center' }}>
                          {HeartLike} <span style={{ marginRight: '10px', marginLeft: '4px' }}>{formatNumber(overview_tab?.best_performing_post?.likes_count || 0)}</span>
                          {/* {InstaShareIcon}  <span style={{ marginRight: '10px', marginLeft: '4px' }}>{formatNumber(10000)} </span> */}

                        </span>
                        <span style={{ display: 'flex', alignItems: 'center' }}>
                          {CommentIcon}  <span style={{ marginRight: '10px', marginLeft: '4px' }}>{formatNumber(overview_tab?.best_performing_post?.comments_count || 0)}</span>

                        </span>
                      </LikesStyle>
                    </div>
                    <Span>
                      This data is observed from {startDateParsed} to {endDateParsed}
                    </Span>
                  </BestPerfMainDiv>
                </ChildContainer>
              )}
            </Container>
          )}

          {(isSectionEnabled('Volume') || isSectionEnabled('Trends in User Activity')) && (
            <ChildContainer>
              <TrendsInUserActivity
                data1={
                  chartType !== 'Engagements'
                    ? {
                      trends_in_user_activity:
                        resetFlag === true && filteredData
                          ? filteredData?.volume
                          : overview_tab?.volume,
                    }
                    : {
                      trends_in_user_activity:
                        resetFlag === true && filteredData
                          ? filteredData?.trends_in_user_activity
                          : overview_tab?.trends_in_user_activity,
                    }
                }
                ylabel={chartType === 'Engagements' ? 'Engagement' : 'Volume'}
                title={
                  chartType === 'Engagements'
                    ? 'Trends in User Activity'
                    : 'Volume'
                }
                hideDropdown={hideDropdown}
                startDate={startDateParsed}
                endDate={endDateParsed}
                formatValue={formatValue}
                showFilters={true}
                setChartType={(data) => setChartType(data)}
                dataPointClickEnabled={true}
                onEmitTimeSpanClick={setWeekType}
                channel={channel}
                handleDataPoint={(data) => {
                  setIsLoading(true);
                  setGraphData(null);
                  handleDataInsightsFetch(data?.payload);
                  setIsLoading(false);
                  setShowSidePanel(true);
                }}
                infoText={
                  chartType === 'Engagements'
                    ? 'Track the total engagement on posts, combining likes, comments, reposts, and views, over a specified time period.'
                    : 'Track the total number of posts over a specified time period.'
                }
                typeVal='instagram'
              />
            </ChildContainer>
          )}
          {isSectionEnabled('EngageMap') && (
            <DynamicCorrelationGraph
              correlationAnalysisData={overview_tab?.heat_map?.engagement_count}
              startDate={startDateParsed}
              endDate={endDateParsed}
              likesData={overview_tab?.heat_map?.likes_count}
              repliesData={overview_tab?.heat_map?.reply_count}
              retweetData={overview_tab?.heat_map?.retweet_count}
              viewData={overview_tab?.heat_map?.view_count}
              commentsData={overview_tab?.heat_map?.comments_count}
              sharesData={overview_tab?.heat_map?.shares_count}
            ></DynamicCorrelationGraph>
          )}
        </Wrapper>
      )}
    </>
  );
};

export default OverviewTabInsta;